<template>
    <span
        v-b-tooltip.hover
        class="icon-139-hour"
        :title="$translate('this_culture_is_longer_than_139_hours')"
    >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <!--!Font Awesome Pro 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.-->
            <path
                d="M256 8C119 8 8 119.1 8 256c0 137 111 248 248 248s248-111 248-248C504 119.1 393 8 256 8zm0 448c-110.5 0-200-89.4-200-200 0-110.5 89.5-200 200-200 110.5 0 200 89.5 200 200 0 110.5-89.4 200-200 200zm0-338c23.2 0 42 18.8 42 42s-18.8 42-42 42-42-18.8-42-42 18.8-42 42-42zm56 254c0 6.6-5.4 12-12 12h-88c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h12v-64h-12c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h64c6.6 0 12 5.4 12 12v100h12c6.6 0 12 5.4 12 12v24z"
            />
        </svg>
    </span>
</template>

<script>
export default {
    name: 'Icon139Hour'
}
</script>

<style lang="scss" scoped>
.icon-139-hour {
    margin-left: 0.3rem;
    fill: $primary;

    svg {
        margin-top: -0.125rem;
        width: 1rem;
    }
}
</style>
